const toggleBtn = document.querySelector('.js-hamburger');
const mobileMenu = document.querySelector('.js-mobile-menu');

if (toggleBtn && mobileMenu) {
	toggleBtn.addEventListener('click', () => {
		toggleBtn.classList.toggle('active');
		mobileMenu.classList.toggle('active');

		document.body.classList.toggle('mobile-menu-opened');
	});
}
